import { Snackbar } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import WorkstationService from "../../../../../services/Production/WorkstationService";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  getAllDepts,
  getDeptInfoCrewById,
} from "../../../../../services/RHService/DepartementService";
import withLoader from "../../../../../components/layouts/WithLoader";
import WarehouseService from "../../../../../services/WarehouseService";
const WorkstationDetails = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const [workstation, setWorkstation] = useState(null);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [description, setDescription] = useState("");
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [capacity, setCapacity] = useState(0);
  const [electricity, setElectricity] = useState(0);
  const [location, setLocation] = useState(0);
  const [consommable, setConsommable] = useState(0);
  const [salaires, setSalaires] = useState(0);
  const [showCrew, setShowCrew] = useState(false);
  const [defaultDepartementId, setDefaultDepartementId] = useState(0);
  const [listCrewId, setListCrewId] = useState([]);
  const [crewSelectPlaceHolder, setCrewSelectPlaceHolder] = useState(
    "Choisir les équipes"
  );
  const [allCrews, setAllCrews] = useState([]);

  const [availableDepartement, setAvailableDepartement] = useState([]);
  const [selectedOptionDepartement, setSelectedOptionDepartement] =
    useState(null);
  const [departementSelectPlaceHolder, setDepartementSelectPlaceHolder] =
    useState("Choisir un département");
  const [selectedOptionCrew, setSelectedOptionCrew] = useState(null);
  const [selectedOptionEntre, setSelectedOptionEntre] = useState(null);
  const [selectedOptionSortie, setSelectedOptionSortie] = useState(null);

  const [allWarehouse, setAllWarehouse] = useState([{}]);
  const [warehouseEntreId, setWarehouseEntreId] = useState(0);
  const [warehouseSortieId, setWarehouseSortieId] = useState(0);
  const [warehouseEntreSelectPlaceHolder, setWarehouseEntreSelectPlaceHolder] =
    useState("Choisir...");
  const [
    warehouseSortieSelectPlaceHolder,
    setWarehouseSortieSelectPlaceHolder,
  ] = useState("Choisir...");

  const [warehouses, setWarehouses] = useState([]);
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        // console.log("response", response);
        if (response.data.success) {
          setWarehouses(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
    startLoading();
    getAllDepts(getCurrentUserId())
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableDepartement(response.data.success);
          response.data.success.map((element, i) => {
            if (i === 0) {
              setDefaultDepartementId(element.id);
            }
            setAvailableDepartement((oldArray) => [
              ...oldArray,
              {
                value: element.idDept,
                label: element.nomDept,
              },
            ]);
          });
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de station de travail");
        }
      })
      .catch((e) => {
        console.log("error in get all departement", e);
      })
      .finally(() => {
        stopLoading();
      });
    WorkstationService.getWorkstationsById(
      sessionStorage.getItem("idWorkstation")
    )
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setWorkstation(response.data.success);
          setDescription(response.data.success.description);
          setCode(response.data.success.code);
          setName(response.data.success.name);
          setCapacity(response.data.success.capacity);
          setElectricity(response.data.success.electricityPerHour);
          setLocation(response.data.success.locationPerHour);
          setConsommable(response.data.success.costConsommablePerHour);
          if (response.data.success.crews) {
            // listIdCrews.push(element.value);
            response.data.success.crews.map((crew, i) =>
              listCrewId.push({ value: crew.id, label: crew.nomEquipe })
            );
            // setListCrewId
          }
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de station de travail");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, []);

  useEffect(() => {
    startLoading();
    warehouses &&
      warehouses.map((element) => {
        let exist = false;
        if (allWarehouse.length !== 0) {
          for (let index = 0; index < allWarehouse.length; index++) {
            if (allWarehouse[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouse((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
    stopLoading();
  }, [warehouses]);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const onChangeDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };

  const onChangeCodeHandler = (event) => {
    setCode(event.target.value);
  };
  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };
  const onValidWorkstationHandler = () => {
    let listIdCrews = [];
    listCrewId &&
      listCrewId.map((element, i) => {
        listIdCrews.push(element.value);
      });
    let workstationModel = {
      idWorkstation: sessionStorage.getItem("idWorkstation"),
      name: name,
      idUser: getCurrentUserId(),
      description: description,
      capacity: capacity,
      electricityPerHour: electricity,
      locationPerHour: location,
      costConsommablePerHour: consommable,
      warehouseEntreId:warehouseEntreId,
      warehouseSortieId:warehouseSortieId,
      listIdCrews: listIdCrews,
    };
    console.log("workstationModel", workstationModel);
    WorkstationService.updateWorkstation(workstationModel)
      .then((response) => {
        if (response.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/workstations`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  };
  const handlerCapacity = (event) => {
    setCapacity(event.target.value);
  };
  const handlerElectricity = (event) => {
    setElectricity(event.target.value);
  };
  const handlerLocation = (event) => {
    setLocation(event.target.value);
  };
  const handlerConsommable = (event) => {
    setConsommable(event.target.value);
  };
  const handlerSalaires = (event) => {
    setSalaires(event.target.value);
  };
  const onChangeSelectedCrew = (selectedOption) => {
    setSelectedOptionCrew();
    setListCrewId(selectedOption);
  };
  const onGetCrewByDept = () => {
    getDeptInfoCrewById(defaultDepartementId)
      .then((response) => {
        setAllCrews([]);
        if (response.data) {
          // setAllCrews(response.data.success.crews);
          // setAvailableDepartement(response.data.success);
          response.data.crews.map((element, i) => {
            setAllCrews((oldArray) => [
              ...oldArray,
              {
                value: element.idEquipe,
                label: element.nomEquipe,
              },
            ]);
          });
          setShowCrew(true);
        } else {
          setAllCrews([]);
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  };

  const crewDetail = () => {
    if (showCrew) {
      console.log("inCrewDetail");

      return (
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label>Choisir les équipes</label>

              <Select
                styles={styles}
                isMulti
                closeMenuOnSelect={true}
                components={animatedComponents}
                defaultValue={selectedOptionCrew}
                onChange={onChangeSelectedCrew}
                options={allCrews}
                placeholder={crewSelectPlaceHolder}
              />
            </div>
          </div>
        </div>
      );
    }
  };
  const onChangeEntreSelectedWarehouse = (selectedOptionn) => {
    setSelectedOptionEntre();
    setWarehouseEntreId(selectedOptionn.value);
    setWarehouseEntreSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSortieSelectedWarehouse = (selectedOptionn) => {
    setSelectedOptionSortie();
    setWarehouseSortieId(selectedOptionn.value);
    setWarehouseSortieSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedDepartement = (selectedOption) => {
    setSelectedOptionDepartement();
    setDefaultDepartementId(selectedOption.value);
  };
  return (
    workstation !== null && (
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">Home</li>
                  <li class="breadcrumb-item active">
                    Details station de travail
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content ">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div className="card-header">
                    <h5 className="card-title">
                      Station de travail: {workstation.code}-{workstation.name}
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor="inputName">Code</label>
                          <input
                            defaultValue={workstation.code}
                            // placeholder="Ajouter réference "
                            onChange={onChangeCodeHandler}
                            type="text"
                            id="inputName"
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label htmlFor="inputName">Libellé</label>
                          <input
                            defaultValue={workstation.name}
                            // placeholder="Ajouter libellé "
                            onChange={onChangeNameHandler}
                            type="text"
                            id="inputName"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div class="form-group">
                          <label>Capacité</label>

                          <input
                            defaultValue={workstation.capacity}
                            onChange={handlerCapacity}
                            type="number"
                            min="0"
                            id="inputClientCompany"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div class="form-group">
                          <label>Cout éléctricité</label>

                          <input
                            defaultValue={workstation.electricityPerHour}
                            onChange={handlerElectricity}
                            type="number"
                            min="0"
                            id="inputClientCompany"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div class="form-group">
                          <label>Cout de la location</label>

                          <input
                            defaultValue={workstation.locationPerHour}
                            onChange={handlerLocation}
                            type="number"
                            min="0"
                            id="inputClientCompany"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div class="form-group">
                          <label>Cout des consommables</label>

                          <input
                            defaultValue={workstation.costConsommablePerHour}
                            onChange={handlerConsommable}
                            type="number"
                            min="0"
                            id="inputClientCompany"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      workstation crew
                      {workstation.crews != null &&
                        workstation.crews.map((crew, i) => (
                          <div key={i} className="col-sm-12">
                            <label>{crew.nomEquipe}</label>
                          </div>
                        ))}
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Choisir le département</label>
                          <div className="input-group">
                            <div
                              className="input-group-prepend"
                              style={{ width: "95%" }}
                            >
                              <Select
                                styles={styles}
                                // isMulti
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                defaultValue={selectedOptionDepartement}
                                onChange={onChangeSelectedDepartement}
                                options={availableDepartement}
                                placeholder={departementSelectPlaceHolder}
                              />
                            </div>
                            <div className=" input-group-append">
                              <button
                                onClick={onGetCrewByDept}
                                type="button"
                                class="btn btn-dark"
                              >
                                <i class="fas  fa-solid fa-arrow-down"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {crewDetail()}

                    <div className="row">
                      <div className="col-sm-6">
                        {" "}
                        <label> Dépôt entré actuel : {workstation.warehouseEntreeName}</label>
                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionEntre}
                          onChange={onChangeEntreSelectedWarehouse}
                          options={allWarehouse}
                          placeholder={warehouseEntreSelectPlaceHolder}
                        />
                      </div>
                      <div className="col-sm-6">
                        {" "}
                        <label> Dépôt sortie actuel : {workstation.warehouseSortieName}</label>
                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionSortie}
                          onChange={onChangeSortieSelectedWarehouse}
                          options={allWarehouse}
                          placeholder={warehouseSortieSelectPlaceHolder}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="inputDescription">Description</label>
                          <textarea
                            defaultValue={workstation.description}
                            // placeholder="Saisir..."
                            onChange={onChangeDescriptionHandler}
                            id="inputDescription"
                            className="form-control"
                            rows={2}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer" style={{ marginTop: "1%" }}>
                    <button
                      class="btn btn-dark float-right"
                      style={{ marginTop: "1%" }}
                      onClick={onValidWorkstationHandler}
                    >
                      Modifier
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Snackbar
          open={openErrorAlert}
          autoHideDuration={2000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleEroorClose} severity="error">
            {errorAlertText}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openSuccessAlert}
          autoHideDuration={2000}
          onClose={handleSuccessClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert
            variant="filled"
            onClose={handleSuccessClose}
            severity="success"
          >
            {successAlertText}
          </Alert>
        </Snackbar>
      </div>
    )
  );
};
export default withLoader(WorkstationDetails);
